import React, { useState ,useEffect,} from 'react';
import './Header.css'
import { Avatar, Col, Row, Popover, Badge, notification } from 'antd'
import { UserOutlined,NotificationOutlined, SettingOutlined, LogoutOutlined } from '@ant-design/icons'
import { useNavigate } from 'react-router-dom' 
import { googleLogout, useGoogleLogin } from '@react-oauth/google';
import CampaignIcon from '@mui/icons-material/Campaign';
import DashboardIcon from '@mui/icons-material/Dashboard';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import GradeIcon from '@mui/icons-material/Grade';
import WorkIcon from '@mui/icons-material/Work'; 
import { useStateValue } from '../../Reducer/reducer'
import { actionTypes } from '../../Reducer/StateProvider'
import Notification from '../Notification/Notification';
import axios from 'axios';
import { BaseUrl } from '../Constants/Constants';
import careerdevlogo from '../../Assets/careerdevlogo.png'



const Header = () => {
  const [
    { IsAuthenticated, UserID },
    dispatch,
] = useStateValue();
  let url = window.location.href;
  let splittedUrl = url.split('/')[3];
  const [showNotification, setShowNotification] = useState(false);
  const [notificationCount, setNotificationCount] = useState(0);
  const [courseNotificationCount, setCourseNotificationCount] = useState(0);
  const [userId, setuserId] = useState(UserID);

  const navigate = useNavigate()
  const Profile = localStorage.getItem("Profile");
  const ParsedProfile = JSON.parse( Profile)
  
  // useEffect(() => {
  //   if(ParsedProfile?.user_id){
  //     setuserId( ParsedProfile.user_id)
  //  }else{
  //   localStorage.setItem("IsAuthenticated", "false");
  //  dispatch({
  //    type: actionTypes.SET_ISAUTHENTICATED,
  //    IsAuthenticated: "false"
  //  })
  //   message.success('Please login again to continue!')
  //   navigate('/login')
  //  }
  // }, [])
  
  // console.log(JSON.parse( Profile),"headerprofile")
  useEffect(() => {
    const fetchNotificationCount = async () => {
      try {
        const response = await axios.get(`${BaseUrl}course-mapping/notificationscount/${userId}`, { withCredentials: true });
        if (response.data.status === 'Ok' && response.data.statuscode === 200) {
          setNotificationCount(response.data.data.length);
        } else {
          setNotificationCount(0);
        }
      } catch (err) {
        console.error('Failed to fetch notification count:', err);
        setNotificationCount(0);
      }
    };

    fetchNotificationCount();
    const interval = setInterval(() => {
      fetchNotificationCount();
      console.log("going to fetch notification")
    }, 10000); // 30000 ms = 30 seconds
  
    // Cleanup the interval on component unmount
    return () => clearInterval(interval);
  }, [userId]);

  useEffect(() => {
    const fetchNotificationCount = async () => {
      try {
        const response = await axios.get(`${BaseUrl}course-mapping/notificationscount/${userId}`, { withCredentials: true });
        if (response.data.status === 'Ok' && response.data.statuscode === 200) {
          setCourseNotificationCount(response.data.data.length);
        } else {
          setCourseNotificationCount(0);
        }
      } catch (err) {
        console.error('Failed to fetch notification count:', err);
        setNotificationCount(0);
      }
    };

    fetchNotificationCount();
    const interval = setInterval(() => {
      fetchNotificationCount();
      console.log("going to fetch notification")
    }, 10000); // 30000 ms = 30 seconds
  
    // Cleanup the interval on component unmount
    return () => clearInterval(interval);
  }, [userId]);

  const handleClick = (e) => {
    console.log(e)
    if (e == 'Dashboard') {
      navigate(`/`)
    }
    if (e == 'Career Program') {
      navigate(`/career-program`)
    }
    if (e == "Courses") {
      navigate(`/courses`)
    }
    if (e == 'gradebook') {
      navigate(`/gradebook`)
    }
    if (e == 'Training Module') {
      navigate(`/training`)
    }
  }

  const handleNotificationClick = () => {
    setShowNotification(!showNotification); // Toggle notification visibility
    if (!showNotification) {
      setNotificationCount(0); // Reset notification count
      setCourseNotificationCount(0)
  }
  };

  const handleSettings = () => {
    navigate(`/settings`)
  }
  const handleLogout = () => {
    axios.get(`${BaseUrl}auth/logout`, {withCredentials:true})
      .then((res) => {
        notification.success({
          message: 'Logged out successfully',
        });
         navigate('/login');
      })
      .catch((err) => {
        notification.error({
          message: 'Logout failed. Redirecting...',
        });
        navigate('/login')
      })
    googleLogout();
    localStorage.removeItem("IsAuthenticated");
    localStorage.removeItem("Profile");
    localStorage.removeItem("companyId");
    dispatch({
      type: actionTypes.SET_ISAUTHENTICATED,
      IsAuthenticated: "false"
    })
                dispatch({
                  type: actionTypes.SET_UserID,
                  UserID: ""
                })
                dispatch({
                  type: actionTypes.SET_COMPANYID,
                  companyId: ""
                })
                dispatch({
                  type: actionTypes.SET_IS_LOGGEDIN,
                  isLoggedIn: false
                })
  }
  const ProfileContent = (
    <div className="profileDropdown">
      <div className="profileDropdownItem" onClick={handleSettings}>
        <SettingOutlined className="profileDropdownIcon" />
        <span>Settings</span>
      </div>
      <div className="profileDropdownItem" onClick={handleLogout}>
        <LogoutOutlined className="profileDropdownIcon" />
        <span>Logout</span>
      </div>
    </div>
  )
  const ProfileTitle = (
    <>
      <Row>
        <Col span={4}>
          <Avatar className='headingAvatar' size={35} icon={<UserOutlined />} />
        </Col>
        <Col offset={2} span={16}>
          <p className='Username'>{Profile ? ParsedProfile.name || ParsedProfile.username : "username"} </p>
          <p className='Email'> {Profile ? ParsedProfile.email : "username@valuehealthsol.com"}</p>
        </Col>
      </Row>
    </>
  )

  return (
    <>
      {splittedUrl === 'login' || splittedUrl === 'signup' || splittedUrl === 'forgotpassword' ?
        <></>
        :
        <div className='headerDiv'>
          <div className='headerContainer'>
            <div className='headerLeft'>
              <img 
                width={180} 
                height={45}
                onClick={() => navigate('/')}
                className='headerLogoImg' 
                src='/Logo/Training Nexus 2.jpg' 
                alt='Training Nexus Logo' 
              />
            </div>
            <div className='headerRight'>
              <nav className='headerNav'>
                <div 
                  className={`navItem ${splittedUrl == "" ? "active" : ""}`}
                  onClick={() => handleClick('Dashboard')}
                >
                  <DashboardIcon className="navIcon" />
                  <span>Dashboard</span>
                </div>
                <div
                  className={`navItem ${splittedUrl == "career-program" ? "active" : ""}`}
                  onClick={() => handleClick('Career Program')}
                >
                  <img
                    src={careerdevlogo}
                    alt="Career Program"
                    className="navIcon"
                    style={{height:'30px'}}
                  />
                  <span>Career Development Program</span>
                </div>
                <div 
                  className={`navItem ${splittedUrl == "courses" ? "active" : ""}`}
                  onClick={() => handleClick('Courses')}
                >
                  <MenuBookIcon className="navIcon" />
                  <span>Courses</span>
                </div>
                <div 
                  className={`navItem ${splittedUrl == "gradebook" ? "active" : ""}`}
                  onClick={() => handleClick('gradebook')}
                >
                  <GradeIcon className="navIcon" />
                  <span>Gradebook</span>
                </div>
              </nav>
              <div className='headerActions'>
                <Badge 
                  count={notificationCount + courseNotificationCount} 
                  className="notificationBadge"
                  overflowCount={99}
                >
                  <div className="notificationButton" onClick={handleNotificationClick}>
                    <NotificationOutlined className='notificationIcon' />
                  </div>
                </Badge>
                <Popover 
                  content={ProfileContent}
                  trigger="click" 
                  title={ProfileTitle}
                  placement="bottomRight"
                  overlayClassName="profilePopover"
                >
                  <div className="profileButton">
                    <Avatar className='headingAvatar' size={40} icon={<UserOutlined />} />
                  </div>
                </Popover>
              </div>
            </div>
          </div>
          {showNotification && (
            <Notification 
              userId={userId} 
              onNotificationsViewed={() => setNotificationCount(0)} 
              onClose={handleNotificationClick} 
            />
          )}
        </div>
     
     

      }
      
    </>

  )
}

export default Header